import { useCallback } from 'react';
const useShouldCloseDropdownOnClick = ignoreRefs => {
  return useCallback(event => {
    return !ignoreRefs.some(ref => ref && ref.current && ref.current.contains(event.target));
  }, [ignoreRefs]);
};
export default useShouldCloseDropdownOnClick;